import React from 'react'
import ItemstoBring from './AdditionalSettings/ItemstoBring'
import FAQ from './AdditionalSettings/FAQ'
import ConfirmationEmail from './AdditionalSettings/ConfirmationEmail'
import RequiredDocuments from './AdditionalSettings/RequiredDocuments'
import Agreements from './AdditionalSettings/Agreements'

const AdditionalSettings: React.FC<any> = () => {
  return (
    <div>
      <h1 className="text-14 w-600">Additional Settings</h1>
      <div className="mt-20px">
        <ConfirmationEmail />
      </div>
      <div className="mt-20px">
        <FAQ />
      </div>
      <div className="mt-20px">
        <ItemstoBring />
      </div>
      <div className="mt-20px">
        <Agreements />
      </div>
      <div className="mt-20px">
        <RequiredDocuments />
      </div>
    </div>
  )
}

export default AdditionalSettings
